import { render } from "./ChatIcon.vue?vue&type=template&id=ee252de2"
import script from "./ChatIcon.vue?vue&type=script&lang=js"
export * from "./ChatIcon.vue?vue&type=script&lang=js"

import "./ChatIcon.vue?vue&type=style&index=0&id=ee252de2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatIcon/ChatIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ee252de2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ee252de2', __exports__)) {
    api.reload('ee252de2', __exports__)
  }
  
  module.hot.accept("./ChatIcon.vue?vue&type=template&id=ee252de2", () => {
    api.rerender('ee252de2', render)
  })

}


export default __exports__